"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _components2 = require("components");

var _selectors = require("selectors");

var _bookingCompanies = require("utils/bookingCompanies");

var _pacomo = require("utils/pacomo");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VouchersAvailableNotice = function VouchersAvailableNotice() {
    return _react2.default.createElement(
        "div",
        { className: "alert alert-success", role: "alert" },
        _react2.default.createElement(
            "strong",
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: "formMessages.vouchers.title",
                defaultMessage: "Congratulations, you're good to go!"
            })
        )
    );
};
VouchersAvailableNotice = (0, _pacomo.pacomoTransformer)(VouchersAvailableNotice);

var RequirementSetList = function RequirementSetList(_ref) {
    var requirementCall = _ref.requirementCall,
        requirementSetsByPassenger = _ref.requirementSetsByPassenger,
        params = _ref.params,
        bookingCompany = _ref.bookingCompany;

    var reqSetsForPax = requirementSetsByPassenger && requirementSetsByPassenger[params.passengerId];
    var bookingCompanyObject = _bookingCompanies.bookingCompanies[bookingCompany.id];
    var isGBookingCompany = void 0;
    if (bookingCompanyObject && bookingCompanyObject.name == "G Adventures") {
        isGBookingCompany = true;
    }
    var isGoodToGo = reqSetsForPax && reqSetsForPax.totalReqSets === reqSetsForPax.reqSetsComplete;
    return _react2.default.createElement(
        _components2.LoadingIndicator,
        { inline: true, apiCalls: [requirementCall] },
        isGoodToGo && isGBookingCompany && _react2.default.createElement(VouchersAvailableNotice, null),
        _react2.default.createElement(_components2.RequirementCards, {
            passengerId: params.passengerId,
            requirementSetsByCustomerId: reqSetsForPax
        })
    );
};

RequirementSetList.propTypes = {
    requirementCall: _propTypes2.default.object.isRequired,
    requirementSetsByPassenger: _propTypes2.default.object.isRequired,
    params: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        requirementCall: state.apiCalls.requirementData,
        requirementSetsByPassenger: (0, _selectors.getRequirementSetsByCustomerId)(state),
        bookingCompany: state.booking.booking_company
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RequirementSetList);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/containers/RequirementSetList.js
// module id = 1359
// module chunks = 0